import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "b1fde378-f038-46ce-896e-47deb5a6548b";
class GenerateItemReorderRecordsPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }

    loadState() {
        // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }

    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

                    onExporting={(e) => {
                        if (window.handleDevExtremeDataGridExport) {
                            window.handleDevExtremeDataGridExport(e);
                        }
                    }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    style={{ height: '100%', width: '100%' }}
                //onContentReady={this.DetailInGridContentReady}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column
                        dataField="ItemType"
                        caption="Item Type"
                        allowEditing={false}
                    />
                    <Column
                        dataField="WarehouseId"
                        caption="Warehouse"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ItemCode"
                        caption="Item Code"
                        allowEditing={false}
                    />
                    <Column
                        dataField="LotCode"
                        caption="Lot Code"
                        allowEditing={false}
                    />
                    <Column
                        dataField="MinimumQty"
                        caption="Minimum Qty"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ReorderMethod"
                        caption="Reorder Method"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ReorderMultiple"
                        caption="Reorder Multiple"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="SafetyQty"
                        caption="Safety Qty"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="OnHand"
                        caption="On Hand"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="Available"
                        caption="Available"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="NetAvailable"
                        caption="Net Available"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="Suggested"
                        caption="Suggested"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="OrderQty"
                        caption="Order Qty"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="Cost"
                        caption="Cost"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="SourceTableName"
                        caption="Source Table Name"
                        allowEditing={false}
                    />
                    <Column
                        dataField="VendorItem"
                        caption="Vendor Item"
                        allowEditing={false}
                    />
                    <Column
                        dataField="PurchaseUom"
                        caption="Purchase UOM"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ItemDesc1"
                        caption="Item Desc 1"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ItemDesc2"
                        caption="Item Desc 2"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ReorderQuantityEntered"
                        caption="Reorder Quantity Entered"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="UserDefinedReference1"
                        caption="User Defined Reference 1"
                        allowEditing={false}
                    />
                    <Column
                        dataField="LocationCode"
                        caption="Location Code"
                        allowEditing={false}
                    />
                    <Column
                        dataField="LocationDesc"
                        caption="Location Desc"
                        allowEditing={false}
                    />
                    <Column
                        dataField="PriceCode"
                        caption="Price Code"
                        allowEditing={false}
                    />
                    <Column
                        dataField="PriceDescription"
                        caption="Price Description"
                        allowEditing={false}
                    />
                    <Column
                        dataField="VendorCost"
                        caption="Vendor Cost"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="RequiredDate"
                        caption="Required Date"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ExpectedDate"
                        caption="Expected Date"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                    />
                    <Column
                        dataField="MaximumQty"
                        caption="Maximum Qty"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="UnitsPerPackageQty"
                        caption="Units Per Package Qty"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="InFuture"
                        caption="In Future"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="InReceiving"
                        caption="In Receiving"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="InOrdered"
                        caption="In Ordered"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ManufacturerId"
                        caption="Manufacturer ID"
                        allowEditing={false}
                    />
                    <Column
                        dataField="ManufacturerName"
                        caption="Manufacturer Name"
                        allowEditing={false}
                    />

                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(GenerateItemReorderRecordsPreview);